import axios from "axios";
import {APP_DISPLAY_ADS_API_ENDPOINT} from "../../../../constants/api_urls";
import {getUserToken} from "../../../../utils/functions/userToken";
import { extractErrorMessages } from "pages/displayAdsCampaignCreator/utils/createCampaignDisplayAds";

export const saveAdsCreative = async (payload) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.put(
            `${APP_DISPLAY_ADS_API_ENDPOINT}/api/display-ads/edit-campaign/ads-creative/`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        const errors = extractErrorMessages(error?.response?.data || {});
        const customError = new Error("Failed to save ads creative");
        customError.success = false;
        customError.errors = errors;
        throw customError;
    }
};
